import { getWorkspaceTabDef } from "@/features/workspace/config";

import { useWorkspaceStore } from "./state/workspaceStore";

/**
 * Resolve the post-login landing route from the persisted last-tab.
 *
 * Two entry points call this from ``beforeLoad``:
 *   - ``/_authed`` (dev root — Vite BFF redirects here, ``/`` served by SPA)
 *   - ``/_authed/workspace`` (prod — Gateway routes ``/workspace`` prefix to
 *     the SPA; ``/`` is served by the marketing ``ando-web`` service)
 *
 * Reads ``currentTab`` synchronously from Zustand (no hooks in ``beforeLoad``),
 * resolves via ``WORKSPACE_TAB_DEFS`` map, falls back to ``/workspace/calendar``
 * if the persisted value is unknown (localStorage tampered / tab removed).
 * The route→store back-sync catches drift from deep-links + back/forward.
 */
export function resolveWorkspaceLandingRoute(): string {
  const lastTab = useWorkspaceStore.getState().currentTab;
  return getWorkspaceTabDef(lastTab)?.route ?? "/workspace/calendar";
}
